import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { AlertStore, IAlertStore } from '../alert-store/AlertStore';
import { AuthStore, AuthStoreModel } from '../auth-store/auth-store';
import { CommonCodeStore, ICommonCodeStore } from '../common-code-store/CommonCodeStore';
import { withEnvironment } from '../extensions/withEnvironment';
import { ILoadingStore, LoadingStore } from '../loading-store/LoadingStore';
import { CategoryStore, ICategoryStore } from '../management/category-store/CategoryStore';
import { IResponseStore, ResponseStore } from '../response-store/ResponseStore';

export const RootStoreModel = types
  .model('RootStore')
  .props({
    alertStore: types.optional(AlertStore, {} as IAlertStore),
    loadingStore: types.optional(LoadingStore, {} as ILoadingStore),
    commonCodeStore: types.optional(CommonCodeStore, {} as ICommonCodeStore),
    authStore: types.optional(AuthStoreModel, {} as AuthStore),
    responseStore: types.optional(ResponseStore, {} as IResponseStore),
    // management
    categoryStore: types.optional(CategoryStore, {} as ICategoryStore),
  })
  .extend(withEnvironment);

/**
 * The RootStore instance.
 */
export interface RootStore extends Instance<typeof RootStoreModel> {}

/**
 * The data of a RootStore.
 */
export interface RootStoreSnapshot extends SnapshotOut<typeof RootStoreModel> {}
